// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1PcaS","label":"Section_label__280CY","contentWrap":"Section_contentWrap__KoZ4j","footer":"Section_footer__O2cQh","footerInner":"Section_footerInner__DWPFK"};